import BoothsRouter from '@/components/pages/booth/index.vue';
import Booths from '@/components/pages/booth/Booths.vue';
import BoothImport from '@/components/pages/booth/BoothImport.vue';

export default {
  path: '/booths',
  name: 'BoothsRouter',
  component: BoothsRouter,
  children: [
    {
      path: '/booths',
      component: Booths,
      name: 'Booths',
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: '/booths/import',
      component: BoothImport,
      name: 'BoothImport',
      meta: {
        acceptRoles: ['admin'],
      },
    },
  ],
}
